import React from 'react'
import HeaderFirstWmo from './HeaderFirstWmo'

export default function HeaderFirst(props) {
  const {
    dynamicApiData,
    apiDetails: {
      props: {
        title,
      } = {},
    } = {},
  } = props

  const dynamicData = dynamicApiData || {}
  const pageMeta = dynamicData.meta

  return <HeaderFirstWmo pageMeta={pageMeta} title={title} dynamicData={dynamicData} />
}
